import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';
import styles from './index.less';


export type BadgeStatus = 'default' | 'success' | 'warning' | 'error' | 'processing' | 'disabled';

export interface BadgeProps {
  status?: BadgeStatus;
  disabled?: boolean;
}

const Badge: FC<PropsWithChildren<BadgeProps>> = ({ status = 'default', children }) => {
  const badge = (
    <div className={classNames(styles.badge, styles[status])} />
  )
  if (children) {
    return (
      <div className={styles.wrapper}>
        {badge}
        {children}
      </div>
    )
  }
  return badge;
}

export default Badge;